



























































import { Component, Vue } from 'vue-property-decorator';
import axiosInstance from '@/axios';

enum PaymentStatus {
  PENDING = 'pending',
  PAID = 'payed'
}

@Component({})
export default class Home extends Vue {
  public page: number = 1;
  public amount: number | null = null;
  public url: string | null = null;
  public currency: string = '₽';

  public mounted() {
    const { paymentId } = this.$route.query;
    if (paymentId) {
      this.$emit('loadstart');
      axiosInstance.post(`/pay/${paymentId}`)
        .then((resp) => resp.data)
        .then(({ amount, link, status }) => {
          this.$emit('loadend');
          switch (status) {
            case PaymentStatus.PENDING:
              if (amount && link) {
                this.amount = amount && amount.value || 0;
                this.url = link;
                this.currency = amount && amount.currency || this.currency;
              }
              break;
            case PaymentStatus.PAID:
              return this.$router.push('/already-paid');
            default:
              return this.$router.push('/error?reason=error');
          }
        })
        .catch(() => {
          this.redirect('/error?reason=error');
        });
    } else {
      this.redirect('https://delimobil.ru');
    }
  }

  public redirect(url: string) {
    if (url) {
      window.location.replace(url);
    }
  }
}
